export const getNewUserRoleDescription = {
  Installer:
    "Installers can install hardware for your organisation but will not be able to see any user data",
  Staff:
    "Staff members can only see the residents assigned to them. Staff can also create new residents, complete installations, and assign their residents to their colleagues.",
  Manager:
    "Managers can see all the residents in their organisation. Managers can complete installations, create new residents and staff and assign or remove residents from colleagues.",
};
